export const hideTermsAndConditions = () => {
  $('.inline-bark-terms-container').addClass('d-none');
};
export const showTermsAndConditions = () => {
  $('.inline-bark-terms-container').removeClass('d-none');
};
